// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as MedalComponent} from './Medal.svg';

import Icon, { TIconProps } from '../Icon';

export const IconMedal = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <MedalComponent/>
  </Icon>
));
